import jwt from 'jsonwebtoken';
import Config from 'Config';

const privateKey = `-----BEGIN RSA PRIVATE KEY-----
MIIEogIBAAKCAQEAzUj9y9szPESyMCm0s/aCsB4XzaZs27+l5JY0/w2UcIy+0rWZ
aBJ/IweeyFx9kF3QLZztnSZBibZnOum6gXVxOvUAMoGvnl1odVNGYf2UV9fNEDuP
4kbve/SUbE3TxTS19PPzbu/k42WH0lem62Dw2klaiuweCkhHoKbS+ZvNqULP5CAy
Nc4bX9Cvi13zZyrwKswbCwQhHbXCBA/J1rT+hQusjjCoxj4DpktBQCG6gMCurVL9
Td8vaHDrp/vl4LyKxsudUadlJKZIEINZVJB5AN7mTaRD1hvV6aaxyIej/XEqzstP
Fnya9xHpHcu1DBdaAX8anM/vsjTpNaP9hHqj3wIDAQABAoIBADw/ac0Efhr4BlvA
Qbp3ZI+PpWjDqTstGeDmfJNGRwRpKi/pACbdFtcPC3i+PFO8VLauUcZHTgC+ubk+
k3AfKaYl9XLdQM93loqocAWeSIUnXpWfBXFhZDO66jyG8tnzyFslpZIvcbuTNrNy
6hg2kTlfQeV3urFF2U+65jw/j7JW1I0NHfv61zPTLn8tFMuTIvbaWjUQOnI5df6W
M+2td4GMpjhYwZLmu/RIT5NeVg9tXnRW6AD7dc51kIgzBaBgK/yhDm44mnqjNR9F
ZugIfWpQbJ7tpJVfvZ/uvvRCYbkhd0D3uzidZuMH39t9B8pkH4n1VrOhBAQoDdFb
TJIHkvECgYEA9dLZy15RKx/E1alEEtvYYxJ6chQ8F7faMyTpuez5Mib/+MqzbvHn
PId6nt3OO2qGOxmwjHAzB5qEkceEWsxiEW4h2Agwvlu6ggyF68Cwt4M0ftu2gY4A
WykDYjzU3kftQoLg50kYYqPbXFGj3yY1JyLw3gyQYMlRn8avUZIgOy0CgYEA1ciH
O61I/PBXofNoze2uujcZqj/fcRn+RFzsXuvfBt0ScKR9tMNTMwyM6ob7f/fqkV4q
FuS1CTFopq1j2N6qHWRPArU0oDF8lkD344lJmjdkaK2bMQ8BD0RmUEcU/6O+hLvW
cDWgET3oRtmPXlSs2qayN6cQofr2KRJpUcTHUrsCgYBaRP1ZYt8nmNjtJOUsj7Kc
XvK75ZZTl133Hfz+G3k+43dn4veVLBuf7JgosobC5tE37q0YRTNX/XPlHIEL3rW8
dNbUv902afTJQNQEyJOcMAAc/Y29cWnMD/mAH5qDraIApJL2G69quYUaF5i3nw4x
uvD8eVyjTgo9Q/apW6GeWQKBgDWiW5szPE6JFdNBuBeB/AYn8L5vy+UaOlp4Xazq
zEdyiz/LZOZG4sa57VihiNNwJV9XGoQn2Ot3g+PdOGGea1t4YQIy6AMQp0si/Y4O
UXLpVr2UYI0MUJ298VVOoAwKzq+KWKBKM+BfgbjUuE1YPQ2WKLwho+Cfj8Z6IgYr
sj4lAoGAAkvruwOV0kPU/CB1G+UB6NRZ+YT+QnWGH0p0BmtLReZuYp6SsOEM4R3f
gL/zSjQtWCnu/VkH9h/9SGNk0/lJDPLbncDMBeAtAsbqVWHABxgRJay8iR5CuB7R
Uv6WHTukYOfNy9aQqFAfRobTIbCXiZj+0zrFfdBBD2pMrQw9dQM=
-----END RSA PRIVATE KEY-----`;

export const signWithJwt = payload =>
  jwt.sign(payload, Config.jwtPrivateKey, { algorithm: 'RS256' });
